<div class="signin-box-container ui-g">
    <div class="signin-box-inner-container">
      <div class="signin-box ">
        <div class="sign-comatiner">
  
          <p-panel [showHeader]="false" [style]="{width: '440px', margin: 'auto'}">
            <div class="form-field ui-g-12 ui-g-nopad">
              <div class="form-field ui-g-12 ui-g-nopad text-center">
                <img class="company-logo-background" src='/assets/images/temp/rainbowcare_logo.png'>
              </div>
              <!-- <div class="form-field ui-g-12 switch-btn" translate>label_log_in</div> -->
              <div class="form-field ui-g-12"></div>
            </div>
            <div class="form-control-c">
                <!-- <div class="form-field ui-g-2 ui-g-nopad">
                  <img src=''>
                </div> -->
                <div class="form-control-c">
                    <p class="login-err">Invalid username or password. Please contact Admin for further assistance.</p>
                  <button pButton label="Go back to login page"  class='sign-in-buttons' type="button" 
                    (click)="backToLogin()"></button>
                </div>
              </div>
            <!-- <div class="version-number" style="right: 41%;">Version 1.0.1</div>
            <div class="powered-by" style="right: 25%;">Powered By: <a href="https://rainbow.health/">Rainbow Health LLC</a></div> -->

          </p-panel>
  
        </div>
      </div>
    </div>
  </div>
  